<template>
  <div>
    <h1 class="mb-5">MEDSS Import Review Bin</h1>

    <b-modal id="modal-crud" hide-header hide-footer size="lg">
      <h2>Submission</h2>
      <hr/>
      <SubmissionDetail :submission="submissionData"
        v-on:refresh-list="refresh($event)"/>
    </b-modal>

   
    <b-table hover small responsive show-empty
      :fields="fields"
      :items="submissions"
      :busy="isLoading">
      <template v-slot:cell(actions)="row">
        <b-button variant="primary" size="sm" @click="showSubmission(row.item)" class="mr-1">
          view
        </b-button>
      </template>
      
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:empty="scope">
        <p>No submissions found.</p>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>        

    </b-table>
   
  </div>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import SubmissionDetail from '@/components/SubmissionDetail'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    mixins: [validationMixin],
    components: {
      SubmissionDetail,
    },
    data: () => ({
      criteria: { },
      fields: [
        {key: 'lastName', sortable: true, label: 'Last Name'},
        {key: 'firstName', sortable: true, label: 'First Name'},
        {key: 'dateOfBirth', sortable: true, label: 'DOB'},
        {key: 'medssEventId', sortable: true, label: 'Event Id'},
        {key: 'reviewComments', sortable: true, label: 'Review Comments'},
        {key: 'actions', label: 'Actions'}
      ],
      isLoading: false,
      events: [],
      submissions: [],
      submission: {},
      submissionData: { },
      showInactive: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: null,
        address: null,
        date: null,
        startTime: null,
        endTime: null,
      },
      defaultItem: {
        id: null,
        name: null,
        address: null,
        date: null,
        startTime: null,
        endTime: null,
      },
    }),

    validations() {
        return {
          criteria: { 
            firstName: { required: false, maxLength: maxLength(75)},
            lastName: { required: false, maxLength: maxLength(75)},
            code: { required: false, maxLength: maxLength(15)},
            labid: { required: false, maxLength: maxLength(15)},
          },
          editedItem: {            
            name: {
              required,
              maxLength: maxLength(100),
            },
            address: {
              required,
              maxLength: maxLength(100),
            },
            date: {
              required,              
            },
            startTime: {
              required,              
            },
            endTime: {
              required,              
            },
            active: { },
          }
        }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Event' : 'Edit Event'
      }
    },

    watch: {
      events() {
        this.isLoading = false
      },
      showInactive() {
        this.fetchEvents()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      fetchEvents() {
          this.isLoading = true;
          let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/search/submission/review`
           
          axios.get(fullUrl)
            .then(response => {
                this.events = response.data;
                this.isLoading = false;
            })
      },

      refresh(b) {
        this.search()
      },

      search() {
        this.isLoading = true
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/search/submission/review`)
            .then(response => {
                this.submissions = response.data
                this.isLoading = false;
            })
      },

      async showSubmission(item) {
        await this.loadSubmission(item.id)
      },

      async loadSubmission(code) {
        this.isLoading = true
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/registration/code/${code}`)
          .then(response => {
              this.submissionData = response.data
              this.isLoading = false
              this.$bvModal.show('modal-crud')
          })
      },

      initialize () {
        this.search()
      },

      editItem (item) {
        this.editedIndex = this.events.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$bvModal.show('modal-crud')
      },

      deleteItem (item) {
        const index = this.events.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.events.splice(index, 1)
      },

      close () {
        this.$bvModal.hide('modal-crud')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.$v.$reset()
          this.fetchEvents()
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/events`, this.editedItem)
            .then(response => { 
              this.fetchEvents()
                this.$bvToast.toast('Event Updated', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        } else {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/events`, this.editedItem)
            .then(response => { 
              this.fetchEvents()
                this.$bvToast.toast('Event Saved', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        }
        this.close()
      },
    }
  }
</script>